import React from 'react';
import { Alert, Flex, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useAppSelector } from '@shared/hooks/use-app-selector';
import { isAdmin } from '@shared/utils';
import { SEVERITY } from '../../../constants';
import { t } from '../../../utils/i18n';

export function SMSUsageLimitNotification() {
  const currentMerchant = useAppSelector((state) => state.currentMerchant);
  const currentAccount = useAppSelector((state) => state.currentAccount);
  const currentNotifications = useAppSelector((state) => state.notifications);
  const { severity } = currentNotifications;

  const shouldShowNotification =
    severity === SEVERITY.WARNING || severity === SEVERITY.DANGER;

  const isUserAdmin = isAdmin({ currentAccount, currentMerchant });

  if (!shouldShowNotification) return null;

  return (
    <Alert
      showIcon
      closable
      icon={<MailOutlined />}
      type={severity === SEVERITY.WARNING ? 'warning' : 'error'}
      data-testid="sms-usage-limit-notification"
      message={
        <Flex gap={6} justify="center" align="center">
          <Typography.Text>
            {severity === SEVERITY.WARNING
              ? t('sms-info.mild-warning-start')
              : t('sms-info.danger-warning-start')}
          </Typography.Text>
          {isUserAdmin ? (
            <Typography.Link href={`/settings/sms-settings`} data-route>
              {t('sms-info.warning-middle-settings')}
            </Typography.Link>
          ) : (
            <Typography.Text>
              {t('sms-info.warning-middle-settings')}
            </Typography.Text>
          )}
          <Typography.Text>
            {severity === SEVERITY.WARNING
              ? t('sms-info.mild-warning-end')
              : t('sms-info.danger-warning-end')}
          </Typography.Text>
        </Flex>
      }
    />
  );
}
